// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1113n","rootSmall":"AddTileButton_rootSmall__1mYGC"};